<template lang="html">
  <div class="inner-modal">
    <div class="head-modal row">
      <div class="title column">
        <div class="head-modal-title">
          Informations Société
        </div>
        <div class="head-modal-emphase">
          Complétez les informations de la société (personne morale)
        </div>
      </div>
    </div>
    <div class="body-modal">
      <form class="form-ui column default-form-ui">
        <!-- Nom de l'entreprise -->
        <div class="form-elem-container">
          <div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('companyName')}">
            <label for="companyName">Nom de l'entreprise *</label>
            <input
              v-validate="'required'"
              type="text"
              name="companyName"
              v-model="companyData.companyName"
            >
          </div>
          <div v-if="errors.has('companyName')" class="error-message">{{ errors.first('companyName') }}</div>
        </div>

        <!-- Numéro d'immatriculation -->
        <div class="form-elem-container">
          <div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('registrationNumber')}">
            <label for="registrationNumber">Numéro d'immatriculation (SIREN/SIRET) *</label>
            <input
              v-validate="'required'"
              type="text"
              name="registrationNumber"
              v-model="companyData.registrationNumber"
            >
          </div>
          <div v-if="errors.has('registrationNumber')" class="error-message">{{ errors.first('registrationNumber') }}</div>
        </div>

        <!-- Adresse du siège social -->
        <div class="form-elem-container">
          <div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('headquartersAddress')}">
            <label for="headquartersAddress">Adresse du siège social *</label>
            <textarea
              v-validate="'required'"
              name="headquartersAddress"
              v-model="companyData.headquartersAddress"
              rows="3"
            ></textarea>
          </div>
          <div v-if="errors.has('headquartersAddress')" class="error-message">{{ errors.first('headquartersAddress') }}</div>
        </div>

        <!-- Régime Fiscal -->
        <div class="form-elem-container ctn-select ctn-label">
          <label for="taxRegime">Régime Fiscal *</label>
          <custom-select
            :items="taxRegimes"
            :selected="companyData.taxRegime"
            :solo="true"
            @change="companyData.taxRegime = $event"
          />
        </div>

        <!-- Activités -->
        <div class="form-elem-container">
          <div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('activities')}">
            <label for="activities">Activités *</label>
            <textarea
              v-validate="'required'"
              name="activities"
              v-model="companyData.activities"
              rows="4"
            ></textarea>
          </div>
          <div v-if="errors.has('activities')" class="error-message">{{ errors.first('activities') }}</div>
        </div>

        <!-- Dirigeants -->
        <div class="form-elem-container">
          <label class="field-label">Dirigeant(s) *</label>
          <div v-for="(manager, index) in companyData.managers" :key="'manager-' + index" class="dynamic-field-row">
            <div class="ctn-input" v-inputUI>
              <input
                type="text"
                v-model="companyData.managers[index]"
                placeholder="Nom et prénom du dirigeant"
              />
            </div>
            <button
              type="button"
              class="btn-icon btn-remove"
              @click="removeManager(index)"
              v-if="companyData.managers.length > 1"
            >
              <span class="icon-trash">x</span>
            </button>
          </div>
          <div class="btn btn-gold btn-add-field" @click="addManager">
            <span class="icon-plus">+</span> Ajouter un dirigeant
          </div>
        </div>

        <!-- Bénéficiaires effectifs -->
        <div class="form-elem-container">
          <label class="field-label">Bénéficiaires effectifs *</label>
          <div v-for="(beneficiary, index) in companyData.beneficiaries" :key="'beneficiary-' + index" class="dynamic-field-row">
            <div class="ctn-input" v-inputUI>
              <input
                type="text"
                v-model="companyData.beneficiaries[index]"
                placeholder="Nom du bénéficiaire effectif"
              />
            </div>
            <button
              type="button"
              class="btn-icon btn-remove"
              @click="removeBeneficiary(index)"
              v-if="companyData.beneficiaries.length > 1"
            >
              <span class="icon-trash">x</span>
            </button>
          </div>
          <div class="btn btn-gold btn-add-field" @click="addBeneficiary">
            <span class="icon-plus"></span> Ajouter un bénéficiaire effectif
          </div>
        </div>

        <!-- Confirmation documents -->
        <div class="form-elem-container documents-confirmation">
          <p class="document-text">
            En tant que représentant légal je confirme avoir transmis les documents suivants :
            une copie du K-bis de moins de 3 mois ou équivalent, Copie des statuts,
            Dernier bilan/compte de résultat ou tout au moins un état financier.
          </p>
          <div class="toggle-row row">
            <custom-toggle :value="companyData.documentsConfirmed" @change="companyData.documentsConfirmed = $event" />
            <label class="toggle-label">Je confirme avoir transmis les documents</label>
          </div>
        </div>

        <!-- Confirmation signature -->
        <div class="form-elem-container signature-confirmation">
          <div class="label solo bold">
            Je confirme que les informations renseignées sont exactes
          </div>
          <div class="toggle-row row">
            <custom-toggle :value="companyData.signatureConfirmed" @change="companyData.signatureConfirmed = $event" />
            <label class="toggle-label">Je confirme l'exactitude des informations</label>
          </div>
          <div class="info-text" v-if="isAdvisor">
            En cliquant sur "Demande de signature électronique" un e-mail sera envoyé au client lui permettant de signer électroniquement les informations de la société que vous avez complété.
          </div>
          <div class="info-text" v-if="!isAdvisor">
            En cliquant sur "Signer" vous allez être redirigé vers notre module de signature électronique afin de valider la saisie des informations de votre société.
          </div>
        </div>

        <transition name="bounce">
          <div class="alert alert-warning" role="alert" v-if="signaturePopupBlocked">
            <div class="alert-wrapper row">
              <span class="icon icon-alert">⚠️</span>
              <div class="alert-content column">
                <p>
                  Votre navigateur a pu bloquer la fenêtre d'accès à la signature.
                  <br>
                  C'est courant, cliquez sur le bouton à droite pour accéder au service de signature.
                </p>
              </div>
              <div class="btn btn-red" @click="showUnlockPopupTuto = true">
                Voir les instructions
              </div>
            </div>
          </div>
        </transition>

        <div class="ctn-cta right row">
          <div class="btn btn-gold" @click="close">Annuler</div>
          <div class="btn btn-red" @click="save" v-if="!companyData.documentsConfirmed || !companyData.signatureConfirmed">Sauvegarder</div>
          <div class="btn btn-red" :class="{'btn-disabled': !companyData.signatureConfirmed}" @click="signDocument" v-else>
            <template v-if="isAdvisor">Demande de signature électronique</template>
            <template v-else>Signer</template>
          </div>
        </div>
      </form>
    </div>

    <!-- Modal RGPD -->
    <base-modal :show="showRgpdModal" @close="showRgpdModal = false" :content="modalRgpd" />

    <!-- Modal UnlockSignaturePopupTutorial -->
    <unlock-signature-popup-tutorial
      v-if="showUnlockPopupTuto"
      @close="showUnlockPopupTuto = false"
    />
  </div>
</template>

<script>
import emma from '@/common/services/Emma'
import CustomToggle from '@/common/components/Form/CustomToggle'
import CustomSelect from '@/common/components/Form/CustomSelect'
import ModalRgpdCompany from '@/common/components/CompanyInformation/modal/RgpdCompany'
import UnlockSignaturePopupTutorial from '@/common/components/UnlockSignaturePopupTutorial'
import UniversignResource from '@/common/resources/Universign'

export default {
  name: 'CompanyInformation',
  props: ['data'],
  components: {
    CustomToggle,
    CustomSelect,
    UnlockSignaturePopupTutorial
  },
  data () {
    return {
      isAdvisor: (process.env.SITE === 'cgpi'),
      showRgpdModal: false,
      modalRgpd: ModalRgpdCompany,
      signaturePopupBlocked: false,
      showUnlockPopupTuto: false,
      taxRegimes: ['Impôt sur les sociétés', 'Impôt sur le revenu', 'TVA'],
      companyData: {
        companyName: '',
        registrationNumber: '',
        headquartersAddress: '',
        taxRegime: '',
        activities: '',
        managers: [''],
        beneficiaries: [''],
        documentsConfirmed: false,
        signatureConfirmed: false
      }
    }
  },
  mounted () {
    this.loadCompanyData()
  },
  methods: {
    loadCompanyData () {
      if (!this.data || !this.data.id) {
        return
      }

      emma.get(`api/clients/${this.data.id}/company-information`)
        .then((result) => {
          if (result.data && result.data.company) {
            const apiData = result.data.company

            // Convertir les propriétés snake_case de l'API en camelCase
            this.companyData = {
              companyName: apiData.company_name || apiData.companyName || '',
              registrationNumber: apiData.registration_number || apiData.registrationNumber || '',
              headquartersAddress: apiData.headquarters_address || apiData.headquartersAddress || '',
              taxRegime: apiData.tax_regime || apiData.taxRegime || '',
              activities: apiData.activities || '',
              managers: apiData.managers || [''],
              beneficiaries: apiData.beneficiaries || [''],
              documentsConfirmed: apiData.documents_confirmed || apiData.documentsConfirmed || false,
              signatureConfirmed: apiData.signature_confirmed || apiData.signatureConfirmed || false
            }

            // S'assurer que les tableaux ont au moins un élément
            if (!this.companyData.managers || this.companyData.managers.length === 0) {
              this.companyData.managers = ['']
            }
            if (!this.companyData.beneficiaries || this.companyData.beneficiaries.length === 0) {
              this.companyData.beneficiaries = ['']
            }
          }
        })
        .catch((error) => {
          console.warn('Error loading company data:', error)
        })
    },

    addManager () {
      this.companyData.managers.push('')
    },

    removeManager (index) {
      this.companyData.managers.splice(index, 1)
    },

    addBeneficiary () {
      this.companyData.beneficiaries.push('')
    },

    removeBeneficiary (index) {
      this.companyData.beneficiaries.splice(index, 1)
    },

    validateForm () {
      const errors = []

      if (!this.companyData.companyName) {
        errors.push('Le nom de l\'entreprise est requis')
      }
      if (!this.companyData.registrationNumber) {
        errors.push('Le numéro d\'immatriculation est requis')
      }
      if (!this.companyData.headquartersAddress) {
        errors.push('L\'adresse du siège social est requise')
      }
      if (!this.companyData.taxRegime) {
        errors.push('Le régime fiscal est requis')
      }
      if (!this.companyData.activities) {
        errors.push('Les activités sont requises')
      }
      if (!this.companyData.managers.some(m => m && m.trim())) {
        errors.push('Au moins un dirigeant est requis')
      }
      if (!this.companyData.beneficiaries.some(b => b && b.trim())) {
        errors.push('Au moins un bénéficiaire effectif est requis')
      }
      if (!this.companyData.documentsConfirmed) {
        errors.push('Vous devez confirmer avoir transmis les documents')
      }

      if (errors.length > 0) {
        this.$notify({
          group: 'default',
          type: 'error',
          title: 'Validation',
          text: errors.join('<br>')
        })
        return false
      }

      return true
    },

    save () {
      if (!this.validateForm()) {
        return
      }

      // Filtrer les champs vides
      const cleanedData = {
        ...this.companyData,
        managers: this.companyData.managers.filter(m => m && m.trim()),
        beneficiaries: this.companyData.beneficiaries.filter(b => b && b.trim())
      }

      emma.post(`api/clients/${this.data.id}/company-information`, cleanedData)
        .then(() => {
          this.$notify({
            group: 'default',
            type: 'success',
            title: 'Succès',
            text: 'Les informations de la société ont été sauvegardées'
          })
          this.$emit('close')
        })
        .catch((error) => {
          this.$notify({
            group: 'default',
            type: 'error',
            title: 'Erreur',
            text: 'Erreur lors de la sauvegarde des informations'
          })
          console.error('Error saving company data:', error)
        })
    },

    signDocument () {
      if (!this.companyData.signatureConfirmed) {
        return
      }

      if (!this.validateForm()) {
        return
      }

      // Filtrer les champs vides
      const cleanedData = {
        ...this.companyData,
        managers: this.companyData.managers.filter(m => m && m.trim()),
        beneficiaries: this.companyData.beneficiaries.filter(b => b && b.trim())
      }

      // Sauvegarder d'abord les données
      emma.post(`api/clients/${this.data.id}/company-information`, cleanedData)
        .then(() => {
          // Ensuite générer le document et lancer la signature
          this.$store.commit('LOADER_IN')
          emma.post(`api/clients/${this.data.id}/company-information/document`)
            .then((result) => {
              const idFile = result.data.file.split('/')[result.data.file.split('/').length - 1]

							// Appeler l'API Universign pour la signature
              UniversignResource.signCompanyInformation(idFile)
                .then((result) => {
                  if (result.data.success) {
                    if (process.env.SITE === 'client') {
                      const win = window.open(result.data.signatureUrl)
                      if (win) {
                        win.focus()
                        this.$emit('close')
                      } else {
                        this.signaturePopupBlocked = true
                      }
                    } else {
                      this.$notify({
                        type: 'success',
                        group: 'default',
                        title: 'Demande de signature envoyée',
                        text: 'La demande de signature a bien été envoyée au client'
                      })
                      this.$emit('close')
                    }
                    this.$store.commit('LOADER_OUT')
                  } else {
                    this.$notify({
                      type: 'error',
                      group: 'default',
                      title: 'Erreur',
                      text: result.data.error || 'Une erreur est survenue lors de la signature'
                    })
                    this.$store.commit('LOADER_OUT')
                  }
                })
                .catch((error) => {
                  this.$notify({
                    type: 'error',
                    group: 'default',
                    title: 'Erreur',
                    text: 'Erreur lors de la demande de signature'
                  })
                  console.error('Error signing company data:', error)
                  this.$store.commit('LOADER_OUT')
                })
            })
            .catch((error) => {
              this.$notify({
                type: 'error',
                group: 'default',
                title: 'Erreur',
                text: 'Erreur lors de la génération du document'
              })
              console.error('Error generating company document:', error)
              this.$store.commit('LOADER_OUT')
            })
        })
        .catch((error) => {
          this.$notify({
            group: 'default',
            type: 'error',
            title: 'Erreur',
            text: 'Erreur lors de la sauvegarde des informations'
          })
          console.error('Error saving company data:', error)
        })
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>

.head-modal {
  justify-content: space-between;

  .title {
    align-items: flex-start;
  }
}

.body-modal {
  overflow-y: auto;
  max-height: 70vh;
}

.ctn-label {
  label {
    text-transform: uppercase;
  }
}

.form-elem-container {
  width: 100%;
  margin-bottom: 1.5rem;

  &.ctn-select.ctn-label {
    margin: 0;
    margin-bottom: 1.5rem;
  }

  label {
    color: #404040;
    font-size: 0.7rem;
    font-family: 'Lato Bold';
    opacity: 0.5;
  }
	label[for='headquartersAddress'], label[for='activities'] {
		top: 1rem;
	}
	label[for='headquartersAddress'].active, label[for='activities'].active {
		top: -1rem;
	}

  textarea {
    width: 100%;
    padding: 0.75rem;
		margin: 0;
    border: 0px solid #ddd;
    font-family: 'Lato';
    font-size: 0.9rem;
    resize: vertical;
    min-height: 80px;
    &:focus {
      outline: none;
      border-color: #c4996e;
    }
  }
}

.field-label {
  display: block;
  color: #404040;
  font-size: 0.7rem;
  font-family: 'Lato Bold';
  opacity: 0.5;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
}

.dynamic-field-row {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  align-items: center;

  .ctn-input {
    flex: 1;
  }

  .btn-icon.btn-remove {
    background: #e74c3c;
    color: white;
    border: none;
    padding: 0.35rem 0.5rem;
		border-radius: 4px;
		margin-left: 1rem;
		font-size: 0.55rem;
    cursor: pointer;
    transition: background 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background: #c0392b;
    }

    span {
      font-size: 1rem;
    }
  }
}

.btn-add-field {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  font-size: 0.85rem;
  padding: 0.5rem 1rem;
}

.documents-confirmation {
  background: #f9f9f9;
  padding: 1.5rem;
  border-radius: 4px;
  border: 1px solid #e0e0e0;

  .document-text {
    margin-bottom: 1rem;
    font-size: 0.85rem;
    line-height: 1.6;
    color: #333;
  }
}

.toggle-row {
  display: flex;
  align-items: center;
  gap: 1rem;

  .toggle-label {
    margin-bottom: 0;
    font-size: 0.9rem;
    color: #333;

    &.bold {
      font-family: 'Lato Bold';
    }
  }
}

.legal-section {
  border-top: 1px solid #e0e0e0;
  padding-top: 1rem;

  .legal-text {
    font-size: 0.8rem;
    line-height: 1.6;
    color: #666;

    p {
      margin-bottom: 0.5rem;
    }
  }

  .link-gold {
    color: #c4996e;
    text-decoration: underline;
    cursor: pointer;
    font-size: 0.8rem;

    &:hover {
      color: #b08858;
    }
  }
}

.signature-confirmation {
  padding: 1.5rem;
  background: #fff9f0;
  border-radius: 4px;
  border: 1px solid #c4996e;
}

.info-text {
  padding: 1rem;
  background: #f0f0f0;
  border-radius: 4px;
  font-size: 0.8rem;
  line-height: 1.6;
  color: #666;
  margin-bottom: 1.5rem;
}

.btn-disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
  pointer-events: none;
}

.error-message {
  color: #e74c3c;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}

.alert {
  margin: 1.5rem 0;
  padding: 1rem;
  border-radius: 4px;
  background: #fff3cd;
  border: 1px solid #ffc107;

  .alert-wrapper {
    display: flex;
    align-items: center;
    gap: 1rem;

    .icon-alert {
      font-size: 1.5rem;
      color: #856404;
    }

    .alert-content {
      flex: 1;

      p {
        margin: 0;
        font-size: 0.85rem;
        line-height: 1.6;
        color: #856404;
      }
    }

    .btn {
      white-space: nowrap;
    }
  }
}

.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.7);
  }
  100% {
    transform: scale(1);
  }
}

.label.solo.bold {
  display: block;
  color: #404040;
  font-size: 0.9rem;
  font-family: 'Lato Bold';
  margin-bottom: 0.75rem;
}

</style>



// WEBPACK FOOTER //
// CompanyInformation.vue?16b3da21